import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import { FONT_WEIGHT_MEDIUM, gray_6 } from '../../../styles/rn';
import { CustomStyleSheet } from '../../../utils/rn/tools';
export default CustomStyleSheet({
  'popup-option-title': {
    textAlign: 'center'
  },
  'popup-option-radio': {
    borderBottomWidth: 1,
    borderBottomColor: gray_6,
    paddingVertical: 12,
    paddingHorizontal: 14
  },
  'popup-option-checkbox-group-title': _objectSpread(_objectSpread({
    paddingTop: 16,
    paddingLeft: 12,
    fontSize: 14
  }, FONT_WEIGHT_MEDIUM), {}, {
    color: 'rgba(0, 0, 0, 0.87)'
  }),
  'popup-option-checkbox-group-end-text': {
    paddingVertical: 16,
    textAlign: 'center',
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.26)'
  }
});